// extracted by mini-css-extract-plugin
export default {"sorting-button":"client-sortable-header_sorting-button__+zHMN","ascending":"client-sortable-header_ascending__G1R5N","active":"client-sortable-header_active__V8bCL"};